<template>

    <div id="agility_tab" class="flex_content">

         <div class="container data_table_view">

            <div v-if="dataLoaded">
                <TableWrapper tableContainerId="positions_table_container">

                    <template v-slot:tableHead>
                        <tr>
                            <th></th>
                            <th data-tooltip="Score de matching">%</th>
                            <th>

                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score1" >1</span>
                                </div>

                            </th>
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score2" >2</span>
                                </div>
                            </th>
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score3" >3</span>
                                </div>
                            </th>
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score4" >4</span>
                                </div>
                            </th>
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score5" >5</span>
                                </div>
                            </th>
                            <th></th>
                        </tr>
                    </template>

                    <template v-slot:tableBody>

                        <tr class="evalution_item_name"
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >

                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>
                            <td class="matching_col"
                                :class="matchingClass(evaluation.saven_test.matching_score.toFixed(0))">
                                {{ evaluation.saven_test.matching_score.toFixed(0) }}%
                            </td>

                            <td class="evalution_item_name">{{ labels[evaluation.saven_test.strengths_order[0][0]] }}</td>
                            <td class="evalution_item_name">{{ labels[evaluation.saven_test.strengths_order[1][0]] }}</td>
                            <td class="evalution_item_name">{{ labels[evaluation.saven_test.strengths_order[2][0]] }}</td>
                            <td class="evalution_item_name">{{ labels[evaluation.saven_test.strengths_order[3][0]] }}</td>
                            <td class="evalution_item_name">{{ labels[evaluation.saven_test.strengths_order[4][0]] }}</td>


                            <!-- <td class="evalution_item_name"
                                v-for="(score, key) in evaluation.saven_test.s3_agility_scores"
                                :index="key" :key="key" >
                                <div>{{ score.toFixed(0) }}</div>
                            </td> -->
                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>

</template>

<script>
import s3StrengthsLabels from '@/locales/s3StrengthsLabels'

export default {
    name: 'PostitionEvalsStrengthTab',
    props: ["evaluations", "currentPosition", "currentRef", "dataLoaded"],
    components: {
    },
    beforeCreate() {},
    data(){
        return {}
    },
    computed: {
        labels(){
            return s3StrengthsLabels[this.$i18n.locale]
        }
    },
    methods: {
        matchingClass(val){
            if(val < 25){return 'low'}
            if(val >= 25 && val < 50){return 'middleLow'}
            if(val >= 50 && val < 75){return 'middleHigh'}
            if(val >= 75){return 'high'}
        }
    }
}
</script>

<style lang="scss" scoped>
th{
    text-align: center!important;
}

td{
    text-align: center;
    color: #8f9aaa;
    height: 42px!important;
    padding-top: 6px!important;
    padding-bottom: 6px!important;
    font-weight: 500;
}
.data_table_view {
    padding-top: 50px;
}
.icon_score_container{
    position: relative;
    text-align: center;
    .score_index{
        font-size: 2rem;
        font-weight: 800;
        z-index: 2;
        position: relative;
        color: $info;
        &.score1{
            margin-left:7px;
        }
        &.score2{
            margin-left:4px;
        }
        &.score3{
            margin-left:4px;
        }
        &.score4{
            margin-left:1px;
        }
        &.score5{
            margin-left:3px;
        }
    }
    .score_laurel{
        position: absolute;
        z-index: 1;
        width: 80px;
        top: -3px;
        margin-left: -27px;
        fill: $primary;
        svg{
            width: 50px;

        }
    }
}
.matching_col{
    font-weight: 700;
    font-size: 1.25rem;
    &.low{
        color: $score-diff4;
    }
    &.middleLow{
        color: $score-diff3;
    }
    &.middleHigh{
        color: $score-diff2;
    }
    &.high{
        color: $score-diff1;
    }
}
.eval_username{
    text-align: left!important;
}
td.eval_username{
    text-align: left!important;
    font-weight: 500;
}
</style>